import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  Card,
  CardBody,
  Input,
  Button,
  Spinner,
  FormFeedback,
  Form,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link, useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PreviewCardHeader from "../../../Components/Common/PreviewCardHeader";
import {
  updateJobType,
  resetJobTypeFlag,
  getJobTypeDetails,
} from "../../../store/actions";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MsgToast from "../../../Components/Common/MsgToast";
import { call } from "redux-saga/effects";
import Select from "react-select";

const JobEdit = () => {
  document.title = "Edit Job Type | Dabbawala";
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [description, setData] = useState();
  // const [jobtype, setjobType] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const {
    isJobTypeUpdate,
    isJobTypeUpdateFail,
    error,
    success,
    details,
  } = useSelector((state) => ({
    isJobTypeUpdate: state.JobTypes.isJobTypeUpdate,
    isJobTypeUpdateFail: state.JobTypes.isJobTypeUpdateFail,
    error: state.JobTypes.error,
    success: state.JobTypes.success,
    details: state.JobTypes.details,
    jobTypeList: state.JobTypes.jobTypeList,
  }));
  console.log(details);
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      type: details && details.type ? details.type : "",
    },
    validationSchema: Yup.object({
      type: Yup.string().required("Please Enter Job Type"),
    }),
    onSubmit: (values) => {
      setIsCreating(true);
      const data = {
        id: id,

        type: values.type,
      };
      dispatch(updateJobType(data));
    },
  });

  useEffect(() => {
    if (isJobTypeUpdate || isJobTypeUpdateFail) {
      setIsCreating(false);
      setTimeout(() => {
        dispatch(resetJobTypeFlag());
        history.push('/jobtypes')
      }, 3000);
    }
  }, [dispatch, isJobTypeUpdate, isJobTypeUpdateFail]);

  useEffect(() => {
    dispatch(getJobTypeDetails({ id: id }));
  }, [dispatch, id]);

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <BreadCrumb title="Edit Job Type" pageTitle="Job Types" pageUrl="/jobtypes" />
          <Row>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Col lg={12}>
                <Card>
                  <PreviewCardHeader title="Edit Job Type" />

                  <CardBody className="card-body">
                    <div className="live-preview">
                      <Row className="gy-4">
                      <Col xxl={3} md={6}>
                          <div>
                            <Label
                              htmlFor="placeholderInput"
                              className="form-label"
                            >
                              Job Type *
                            </Label>
                            <Input
                              type="text"
                              id="placeholderInput"
                              className="form-control"
                              placeholder="Job Type"
                              name="type"
                              value={validation.values.type || ""}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              validate={{
                                required: { value: true },
                              }}
                              invalid={
                                validation.touched.type &&
                                validation.errors.type
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.type &&
                            validation.errors.type ? (
                              <FormFeedback type="invalid">
                                {validation.errors.type}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>

                <div className="text-end mb-4">
                  <Link to="/jobtypes" className="btn btn-danger w-sm me-1">
                    Cancel
                  </Link>
                  <Button
                    color="success"
                    className="btn-load"
                    disabled={isCreating}
                    type="submit"
                  >
                    <span className="d-flex align-items-center">
                      {isCreating && (
                        <Spinner size="sm" className="flex-shrink-0 me-2">
                          {" "}
                          Update{" "}
                        </Spinner>
                      )}
                      <span className="flex-grow-1">Update</span>
                    </span>
                  </Button>
                </div>
              </Col>
            </Form>
          </Row>
          {isJobTypeUpdate ? (
            <MsgToast
              msg={success}
              color="success"
              icon="ri-checkbox-circle-line"
            />
          ) : null}
          {isJobTypeUpdateFail ? (
            <MsgToast msg={error} color="danger" icon="ri-error-warning-line" />
          ) : null}
          <ToastContainer limit={1} closeButton={false} />
        </Container>
      </div>
    </>
  );
};

export default JobEdit;
